jQuery(function($){

  $('html').removeClass('no-js');

  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

});


// CHECK ACTIVE STATE
$( document ).ready(function() {

	if($('.recipe-page').length){
		$( '.recipes-btn' ).addClass( 'active' );
	}

	else if($('#your-shopping-cart').length) {
    	$( '.order-online-btn' ).addClass( 'active' );
    }

    // else if($('#flyer-holder').length) {
    // 	$( '.weekly-flyer-btn' ).addClass( 'active' );
    // }

	});


  /* Wishlist Alert */
  /*==========================*/

  $(".wishlistbutton").click(function(event) {

    // custom name for this
    var thisButton = $(this);
    // heart icon
    var heart = thisButton.find('i');

    // prevent form from submitting
    event.preventDefault();

    // get customer email and product number for ajax form
    var thisCustomer = thisButton.parent().find("input[name='contact[email]']").attr('value');
    var thisProduct = thisButton.parent().find("input[name='contact[tags]']").attr('value');

    // Submit 'contact' form to add tag to current customer for favorite
      // build Shopify parameters
      // first segment of url for POST request
      var action = '/contact?';
          // add first parameter and replace special characters with URI formatted ones
          action += encodeURIComponent('form_type') + '=' + encodeURIComponent('customer');
          // add second parameter
          action += '&' + encodeURIComponent('utf8') + '=' + encodeURIComponent('✓');
          // add third parameter
          action += '&' + encodeURIComponent('contact[email]') + '=' + encodeURIComponent(thisCustomer);
          // add fourth parameter
          action += '&' + encodeURIComponent('contact[tags]') + '=' + encodeURIComponent(thisProduct); // Ferrero

      // Submit the form with ajax
      $.ajax({
          type: "POST",
          async: true,
          url: action,
          error: function(jqXHR, textStatus, errorThrown){
            // Request failed
          },
          success: function(response) {


            // find great-grandparent of wish list button to get product name for modal text
//             var prodname = thisButton.parents().eq(2).find(".prod-caption").text();
			   var prodname = thisButton.parent().parent().find(".prod-caption").text();

            // settings if adding to favorites
            if(thisButton.hasClass('empty')){
              // set modal text
              $('#modal-cart-favourite h6').html('has been added to your favourites!');
            // settings if removing from favorites
            } else {
              // set modal text
              $('#modal-cart-favourite h6').html('has been removed from your favourites');
            }

            // Set product name in modal
            $("#modal-cart-favourite .prod-caption").html(prodname);

            // Set modal animation
            setTimeout(function () {$('#modal-cart-favourite').trigger('reveal:close')}, 2000);
            setTimeout(function () {$('.check').addClass('bounceInstart')}, 700);
            setTimeout(function () {$('.check').removeClass('hidden')}, 700);
            setTimeout(function () {$('.check').addClass('hidden')}, 2500);

            // Activate modal
            $('#favouritealert').click();

            // Prepend x to product id for next submission
            thisProduct = 'x' + thisProduct;

            // change attribute on button for multiple clicks
            thisButton.parent().find("input[name='contact[tags]']").attr('value',thisProduct);

            // Change look of button
              // If adding to favorites
              if(thisButton.hasClass('empty')){
                // Remove favorite tag
                thisButton.removeClass('empty');
                // add green heart
                heart.removeClass('fa-heart-o');
                // remove red heart
                heart.addClass('fa-heart');
                thisButton.addClass('already-favorite');
              // If removing from favorites
              } else {
                // Tag as favorite
                // thisButton.addClass('favorite');
                // Change color of background circle
                thisButton.addClass('empty');
                thisButton.removeClass('already-favorite');
                // Change to solid heart
                  // remove green heart
                  heart.addClass('fa-heart-o');
                  // add red heart
                  heart.removeClass('fa-heart');
              }


          } // end success
      }); // end ajax

  }); // end Wishlist Alert



////////////////////////////////////// PLUS MINUS BUTTONS
// CART ONLY
function TextBox_AddToIntValue(targetId,addToValue)
{
    var input = document.getElementById(targetId);
    var textInt = parseInt(input.value);
    if(isNaN(textInt))
    {
        textInt = 0;
    }
    input.value = textInt + addToValue;
}

// ALL OTHER PAGES
function TextBox_AddToIntValuePlus(element,targetId,addToValue)
{
    var input = document.getElementById(targetId);
    var textInt = parseInt(input.value);
	if(isNaN(textInt)){
        textInt = 0;
    }
    else if ((textInt) >= 1){
	 input.value = textInt + addToValue;
	 $(element).closest('.prod-btn').find('.minus-btn').removeClass('invisible');
	 $(element).closest('.prod-btn').find('.minus-btn').addClass('bounceInstart');
    }
}

function TextBox_AddToIntValueMinus(element,targetId,addToValue)
{
    var input = document.getElementById(targetId);
    var textInt = parseInt(input.value);
	if(isNaN(textInt)){
        textInt = 0;
    }
    else if ((textInt) <= 2){
	 input.value = textInt + addToValue;
	 $(element).closest('.prod-btn').find('.minus-btn').addClass('invisible');
	 $(element).closest('.prod-btn').find('.minus-btn').removeClass('bounceInstart');
	    input.value = textInt + addToValue;
    }
    else {input.value = textInt + addToValue;}
}

/*
$("form").submit(function(e) {

    var ref = $(this).find(".quantity");

    $(ref).each(function(){
        if ( $(this).val() < 1 )
        {
            alert("Quantity must be greater then or equal to 1");

            $(this).focus();
            $(this).val(1);

            e.preventDefault();
            return false;
        }
    });  return true;
});
*/


/////////////////////////////////// SCROLLTOTOP
$(document).ready(function(){

	$('.scrollToTop').click(function(){
		$('html, body').animate({scrollTop : 0},200);
		return false;
		setTimeout(function() {
			$('#search-field').focus();
		}, 250);
	});

});

/////////////////////////////////// WEIGHT PREFERENCES
$(document).ready(function(){
	if (Cookies("weightpref") == null) {
    Cookies('weightpref', 'lb', {path: '/', domain: 'supermarchepa.com', expires: 365});
	}
	else if (Cookies("weightpref") == "kg"){
      $( '.kg-holder #tabs li:first-of-type' ).toggleClass('current-kg');
		$( '.kg-holder #tabs li:nth-of-type(2)' ).toggleClass('current-kg');
		};
 });
	
	$(".kg").on("click", function(e) {
	e.preventDefault();
	 $( '.kg-holder #tabs li' ).toggleClass('current-kg');
	 Cookies('weightpref', 'kg', {path: '/',	domain: 'supermarchepa.com',expires: 365});
     location.reload();
	});
	
	$(".lb").on("click", function(e) {
	e.preventDefault();
	$( '.kg-holder #tabs li' ).toggleClass('current-kg');
	Cookies('weightpref', 'lb', {path: '/',	domain: 'supermarchepa.com',expires: 365});
    location.reload();
	});


/////////////////////////////////// ODOMETER
(function() {
  var COUNT_FRAMERATE, COUNT_MS_PER_FRAME, DIGIT_FORMAT, DIGIT_HTML, DIGIT_SPEEDBOOST, DURATION, FORMAT_MARK_HTML, FORMAT_PARSER, FRAMERATE, FRAMES_PER_VALUE, MS_PER_FRAME, MutationObserver, Odometer, RIBBON_HTML, TRANSITION_END_EVENTS, TRANSITION_SUPPORT, VALUE_HTML, addClass, createFromHTML, now, removeClass, requestAnimationFrame, round, transitionCheckStyles, trigger, truncate, wrapJQuery, _jQueryWrapped, _old, _ref, _ref1,
    __slice = [].slice;

  VALUE_HTML = '<span class="odometer-value"></span>';

  RIBBON_HTML = '<span class="odometer-ribbon"><span class="odometer-ribbon-inner">' + VALUE_HTML + '</span></span>';

  DIGIT_HTML = '<span class="odometer-digit"><span class="odometer-digit-spacer">8</span><span class="odometer-digit-inner">' + RIBBON_HTML + '</span></span>';

  FORMAT_MARK_HTML = '<span class="odometer-formatting-mark"></span>';

  DIGIT_FORMAT = '(,ddd).dd';

  FORMAT_PARSER = /^\(?([^)]*)\)?(?:(.)(d+))?$/;

  FRAMERATE = 30;

  DURATION = 2000;

  COUNT_FRAMERATE = 20;

  FRAMES_PER_VALUE = 2;

  DIGIT_SPEEDBOOST = .5;

  MS_PER_FRAME = 1000 / FRAMERATE;

  COUNT_MS_PER_FRAME = 1000 / COUNT_FRAMERATE;

  TRANSITION_END_EVENTS = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd';

  transitionCheckStyles = document.createElement('div').style;

  TRANSITION_SUPPORT = (transitionCheckStyles.transition != null) || (transitionCheckStyles.webkitTransition != null) || (transitionCheckStyles.mozTransition != null) || (transitionCheckStyles.oTransition != null);

  requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

  MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

  createFromHTML = function(html) {
    var el;
    el = document.createElement('div');
    el.innerHTML = html;
    return el.children[0];
  };

  removeClass = function(el, name) {
    return el.className = el.className.replace(new RegExp("(^| )" + (name.split(' ').join('|')) + "( |$)", 'gi'), ' ');
  };

  addClass = function(el, name) {
    removeClass(el, name);
    return el.className += " " + name;
  };

  trigger = function(el, name) {
    var evt;
    if (document.createEvent != null) {
      evt = document.createEvent('HTMLEvents');
      evt.initEvent(name, true, true);
      return el.dispatchEvent(evt);
    }
  };

  now = function() {
    var _ref, _ref1;
    return (_ref = (_ref1 = window.performance) != null ? typeof _ref1.now === "function" ? _ref1.now() : void 0 : void 0) != null ? _ref : +(new Date);
  };

  round = function(val, precision) {
    if (precision == null) {
      precision = 0;
    }
    if (!precision) {
      return Math.round(val);
    }
    val *= Math.pow(10, precision);
    val += 0.5;
    val = Math.floor(val);
    return val /= Math.pow(10, precision);
  };

  truncate = function(val) {
    if (val < 0) {
      return Math.ceil(val);
    } else {
      return Math.floor(val);
    }
  };

  _jQueryWrapped = false;

  (wrapJQuery = function() {
    var property, _i, _len, _ref, _results;
    if (_jQueryWrapped) {
      return;
    }
    if (window.jQuery != null) {
      _jQueryWrapped = true;
      _ref = ['html', 'text'];
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        property = _ref[_i];
        _results.push((function(property) {
          var old;
          old = window.jQuery.fn[property];
          return window.jQuery.fn[property] = function(val) {
            var _ref1;
            if ((val == null) || (((_ref1 = this[0]) != null ? _ref1.odometer : void 0) == null)) {
              return old.apply(this, arguments);
            }
            return this[0].odometer.update(val);
          };
        })(property));
      }
      return _results;
    }
  })();

  setTimeout(wrapJQuery, 0);

  Odometer = (function() {
    function Odometer(options) {
      var e, k, property, v, _base, _i, _len, _ref, _ref1, _ref2,
        _this = this;
      this.options = options;
      this.el = this.options.el;
      if (this.el.odometer != null) {
        return this.el.odometer;
      }
      this.el.odometer = this;
      _ref = Odometer.options;
      for (k in _ref) {
        v = _ref[k];
        if (this.options[k] == null) {
          this.options[k] = v;
        }
      }
      if ((_base = this.options).duration == null) {
        _base.duration = DURATION;
      }
      this.MAX_VALUES = ((this.options.duration / MS_PER_FRAME) / FRAMES_PER_VALUE) | 0;
      this.resetFormat();
      this.value = this.cleanValue((_ref1 = this.options.value) != null ? _ref1 : '');
      this.renderInside();
      this.render();
      try {
        _ref2 = ['innerHTML', 'innerText', 'textContent'];
        for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
          property = _ref2[_i];
          if (this.el[property] != null) {
            (function(property) {
              return Object.defineProperty(_this.el, property, {
                get: function() {
                  var _ref3;
                  if (property === 'innerHTML') {
                    return _this.inside.outerHTML;
                  } else {
                    return (_ref3 = _this.inside.innerText) != null ? _ref3 : _this.inside.textContent;
                  }
                },
                set: function(val) {
                  return _this.update(val);
                }
              });
            })(property);
          }
        }
      } catch (_error) {
        e = _error;
        this.watchForMutations();
      }
      this;
    }

    Odometer.prototype.renderInside = function() {
      this.inside = document.createElement('div');
      this.inside.className = 'odometer-inside';
      this.el.innerHTML = '';
      return this.el.appendChild(this.inside);
    };

    Odometer.prototype.watchForMutations = function() {
      var e,
        _this = this;
      if (MutationObserver == null) {
        return;
      }
      try {
        if (this.observer == null) {
          this.observer = new MutationObserver(function(mutations) {
            var newVal;
            newVal = _this.el.innerText;
            _this.renderInside();
            _this.render(_this.value);
            return _this.update(newVal);
          });
        }
        this.watchMutations = true;
        return this.startWatchingMutations();
      } catch (_error) {
        e = _error;
      }
    };

    Odometer.prototype.startWatchingMutations = function() {
      if (this.watchMutations) {
        return this.observer.observe(this.el, {
          childList: true
        });
      }
    };

    Odometer.prototype.stopWatchingMutations = function() {
      var _ref;
      return (_ref = this.observer) != null ? _ref.disconnect() : void 0;
    };

    Odometer.prototype.cleanValue = function(val) {
      var _ref;
      if (typeof val === 'string') {
        val = val.replace((_ref = this.format.radix) != null ? _ref : '.', '<radix>');
        val = val.replace(/[.,]/g, '');
        val = val.replace('<radix>', '.');
        val = parseFloat(val, 10) || 0;
      }
      return round(val, this.format.precision);
    };

    Odometer.prototype.bindTransitionEnd = function() {
      var event, renderEnqueued, _i, _len, _ref, _results,
        _this = this;
      if (this.transitionEndBound) {
        return;
      }
      this.transitionEndBound = true;
      renderEnqueued = false;
      _ref = TRANSITION_END_EVENTS.split(' ');
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        event = _ref[_i];
        _results.push(this.el.addEventListener(event, function() {
          if (renderEnqueued) {
            return true;
          }
          renderEnqueued = true;
          setTimeout(function() {
            _this.render();
            renderEnqueued = false;
            return trigger(_this.el, 'odometerdone');
          }, 0);
          return true;
        }, false));
      }
      return _results;
    };

    Odometer.prototype.resetFormat = function() {
      var format, fractional, parsed, precision, radix, repeating, _ref, _ref1;
      format = (_ref = this.options.format) != null ? _ref : DIGIT_FORMAT;
      format || (format = 'd');
      parsed = FORMAT_PARSER.exec(format);
      if (!parsed) {
        throw new Error("Odometer: Unparsable digit format");
      }
      _ref1 = parsed.slice(1, 4), repeating = _ref1[0], radix = _ref1[1], fractional = _ref1[2];
      precision = (fractional != null ? fractional.length : void 0) || 0;
      return this.format = {
        repeating: repeating,
        radix: radix,
        precision: precision
      };
    };

    Odometer.prototype.render = function(value) {
      var classes, cls, digit, match, newClasses, theme, wholePart, _i, _j, _len, _len1, _ref;
      if (value == null) {
        value = this.value;
      }
      this.stopWatchingMutations();
      this.resetFormat();
      this.inside.innerHTML = '';
      theme = this.options.theme;
      classes = this.el.className.split(' ');
      newClasses = [];
      for (_i = 0, _len = classes.length; _i < _len; _i++) {
        cls = classes[_i];
        if (!cls.length) {
          continue;
        }
        if (match = /^odometer-theme-(.+)$/.exec(cls)) {
          theme = match[1];
          continue;
        }
        if (/^odometer(-|$)/.test(cls)) {
          continue;
        }
        newClasses.push(cls);
      }
      newClasses.push('odometer');
      if (!TRANSITION_SUPPORT) {
        newClasses.push('odometer-no-transitions');
      }
      if (theme) {
        newClasses.push("odometer-theme-" + theme);
      } else {
        newClasses.push("odometer-auto-theme");
      }
      this.el.className = newClasses.join(' ');
      this.ribbons = {};
      this.digits = [];
      wholePart = !this.format.precision;
      _ref = value.toFixed(this.format.precision).split('').reverse();
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        digit = _ref[_j];
        if (digit === '.') {
          wholePart = true;
        }
        this.addDigit(digit, wholePart);
      }
      return this.startWatchingMutations();
    };

    Odometer.prototype.update = function(newValue) {
      var diff,
        _this = this;
      newValue = this.cleanValue(newValue);
      if (!(diff = newValue - this.value)) {
        return;
      }
      removeClass(this.el, 'odometer-animating-up odometer-animating-down odometer-animating');
      if (diff > 0) {
        addClass(this.el, 'odometer-animating-up');
      } else {
        addClass(this.el, 'odometer-animating-down');
      }
      this.stopWatchingMutations();
      this.animate(newValue);
      this.startWatchingMutations();
      setTimeout(function() {
        _this.el.offsetHeight;
        return addClass(_this.el, 'odometer-animating');
      }, 0);
      return this.value = newValue;
    };

    Odometer.prototype.renderDigit = function() {
      return createFromHTML(DIGIT_HTML);
    };

    Odometer.prototype.insertDigit = function(digit, before) {
      if (before != null) {
        return this.inside.insertBefore(digit, before);
      } else if (!this.inside.children.length) {
        return this.inside.appendChild(digit);
      } else {
        return this.inside.insertBefore(digit, this.inside.children[0]);
      }
    };

    Odometer.prototype.addSpacer = function(chr, before, extraClasses) {
      var spacer;
      spacer = createFromHTML(FORMAT_MARK_HTML);
      spacer.innerHTML = chr;
      if (extraClasses) {
        addClass(spacer, extraClasses);
      }
      return this.insertDigit(spacer, before);
    };

    Odometer.prototype.addDigit = function(value, repeating) {
      var chr, digit, resetted, _ref;
      if (repeating == null) {
        repeating = true;
      }
      if (value === '-') {
        return this.addSpacer(value, null, 'odometer-negation-mark');
      }
      if (value === '.') {
        return this.addSpacer((_ref = this.format.radix) != null ? _ref : '.', null, 'odometer-radix-mark');
      }
      if (repeating) {
        resetted = false;
        while (true) {
          if (!this.format.repeating.length) {
            if (resetted) {
              throw new Error("Bad odometer format without digits");
            }
            this.resetFormat();
            resetted = true;
          }
          chr = this.format.repeating[this.format.repeating.length - 1];
          this.format.repeating = this.format.repeating.substring(0, this.format.repeating.length - 1);
          if (chr === 'd') {
            break;
          }
          this.addSpacer(chr);
        }
      }
      digit = this.renderDigit();
      digit.querySelector('.odometer-value').innerHTML = value;
      this.digits.push(digit);
      return this.insertDigit(digit);
    };

    Odometer.prototype.animate = function(newValue) {
      if (!TRANSITION_SUPPORT || this.options.animation === 'count') {
        return this.animateCount(newValue);
      } else {
        return this.animateSlide(newValue);
      }
    };

    Odometer.prototype.animateCount = function(newValue) {
      var cur, diff, last, start, tick,
        _this = this;
      if (!(diff = +newValue - this.value)) {
        return;
      }
      start = last = now();
      cur = this.value;
      return (tick = function() {
        var delta, dist, fraction;
        if ((now() - start) > _this.options.duration) {
          _this.value = newValue;
          _this.render();
          trigger(_this.el, 'odometerdone');
          return;
        }
        delta = now() - last;
        if (delta > COUNT_MS_PER_FRAME) {
          last = now();
          fraction = delta / _this.options.duration;
          dist = diff * fraction;
          cur += dist;
          _this.render(Math.round(cur));
        }
        if (requestAnimationFrame != null) {
          return requestAnimationFrame(tick);
        } else {
          return setTimeout(tick, COUNT_MS_PER_FRAME);
        }
      })();
    };

    Odometer.prototype.getDigitCount = function() {
      var i, max, value, values, _i, _len;
      values = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
      for (i = _i = 0, _len = values.length; _i < _len; i = ++_i) {
        value = values[i];
        values[i] = Math.abs(value);
      }
      max = Math.max.apply(Math, values);
      return Math.ceil(Math.log(max + 1) / Math.log(10));
    };

    Odometer.prototype.getFractionalDigitCount = function() {
      var i, parser, parts, value, values, _i, _len;
      values = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
      parser = /^\-?\d*\.(\d*?)$/;
      for (i = _i = 0, _len = values.length; _i < _len; i = ++_i) {
        value = values[i];
        values[i] = value.toFixed(this.format.precision);
        parts = parser.exec(values[i]);
        if (parts == null) {
          values[i] = 0;
        } else {
          values[i] = parts[1].length;
        }
      }
      return Math.max.apply(Math, values);
    };

    Odometer.prototype.resetDigits = function() {
      this.digits = [];
      this.ribbons = [];
      this.inside.innerHTML = '';
      return this.resetFormat();
    };

    Odometer.prototype.animateSlide = function(newValue) {
      var boosted, cur, diff, digitCount, digits, dist, end, fractionalCount, frame, frames, i, incr, j, mark, numEl, oldValue, start, _base, _i, _j, _k, _l, _len, _len1, _len2, _m, _ref, _results;
      oldValue = this.value;
      fractionalCount = this.getFractionalDigitCount(oldValue, newValue);
      
      /*if (fractionalCount) {
        newValue = newValue * Math.pow(10, fractionalCount);
        oldValue = oldValue * Math.pow(10, fractionalCount);
      }
      if (!(diff = newValue - oldValue)) {
        return;
      }
      this.bindTransitionEnd();
      digitCount = this.getDigitCount(oldValue, newValue);
      digits = [];
      boosted = 0; */
	    // #hack
	    // number of digits of the integer part
	    fractionalCount = this.getFractionalDigitCount(oldValue, newValue);
	    
	    var nv = (truncate(newValue) + "").length,
	        ov = (truncate(oldValue) + "").length,
	        intergerCount = Math.max(nv, ov);
	
	    if (fractionalCount) {
	        newValue = newValue * Math.pow(10, fractionalCount);
	        oldValue = oldValue * Math.pow(10, fractionalCount);
	    }
	
	    if (!(diff = newValue - oldValue)) {
	        return;
	    }
	
	    this.bindTransitionEnd();
	    digitCount = intergerCount + fractionalCount;  // now useless : this.getDigitCount(oldValue, newValue);
	    digits = [];
	    boosted = 0;
	    // #hack
      for (i = _i = 0; 0 <= digitCount ? _i < digitCount : _i > digitCount; i = 0 <= digitCount ? ++_i : --_i) {
        start = truncate(oldValue / Math.pow(10, digitCount - i - 1));
        end = truncate(newValue / Math.pow(10, digitCount - i - 1));
        dist = end - start;
        if (Math.abs(dist) > this.MAX_VALUES) {
          frames = [];
          incr = dist / (this.MAX_VALUES + this.MAX_VALUES * boosted * DIGIT_SPEEDBOOST);
          cur = start;
          while ((dist > 0 && cur < end) || (dist < 0 && cur > end)) {
            frames.push(Math.round(cur));
            cur += incr;
          }
          if (frames[frames.length - 1] !== end) {
            frames.push(end);
          }
          boosted++;
        } else {
          frames = (function() {
            _results = [];
            for (var _j = start; start <= end ? _j <= end : _j >= end; start <= end ? _j++ : _j--){ _results.push(_j); }
            return _results;
          }).apply(this);
        }
        for (i = _k = 0, _len = frames.length; _k < _len; i = ++_k) {
          frame = frames[i];
          frames[i] = Math.abs(frame % 10);
        }
        digits.push(frames);
      }
      this.resetDigits();
      _ref = digits.reverse();
      for (i = _l = 0, _len1 = _ref.length; _l < _len1; i = ++_l) {
        frames = _ref[i];
        if (!this.digits[i]) {
          this.addDigit(' ', i >= fractionalCount);
        }
        if ((_base = this.ribbons)[i] == null) {
          _base[i] = this.digits[i].querySelector('.odometer-ribbon-inner');
        }
        this.ribbons[i].innerHTML = '';
        if (diff < 0) {
          frames = frames.reverse();
        }
        for (j = _m = 0, _len2 = frames.length; _m < _len2; j = ++_m) {
          frame = frames[j];
          numEl = document.createElement('div');
          numEl.className = 'odometer-value';
          numEl.innerHTML = frame;
          this.ribbons[i].appendChild(numEl);
          if (j === frames.length - 1) {
            addClass(numEl, 'odometer-last-value');
          }
          if (j === 0) {
            addClass(numEl, 'odometer-first-value');
          }
        }
      }
      if (start < 0) {
        this.addDigit('-');
      }
      mark = this.inside.querySelector('.odometer-radix-mark');
      if (mark != null) {
        mark.parent.removeChild(mark);
      }
      if (fractionalCount) {
        return this.addSpacer(this.format.radix, this.digits[fractionalCount - 1], 'odometer-radix-mark');
      }
    };

    return Odometer;

  })();

  Odometer.options = (_ref = window.odometerOptions) != null ? _ref : {};

  setTimeout(function() {
    var k, v, _base, _ref1, _results;
    if (window.odometerOptions) {
      _ref1 = window.odometerOptions;
      _results = [];
      for (k in _ref1) {
        v = _ref1[k];
        _results.push((_base = Odometer.options)[k] != null ? (_base = Odometer.options)[k] : _base[k] = v);
      }
      return _results;
    }
  }, 0);

  Odometer.init = function() {
    var el, elements, _i, _len, _ref1, _results;
    if (document.querySelectorAll == null) {
      return;
    }
    elements = document.querySelectorAll(Odometer.options.selector || '.odometer');
    _results = [];
    for (_i = 0, _len = elements.length; _i < _len; _i++) {
      el = elements[_i];
      _results.push(el.odometer = new Odometer({
        el: el,
        value: (_ref1 = el.innerText) != null ? _ref1 : el.textContent
      }));
    }
    return _results;
  };

  if ((((_ref1 = document.documentElement) != null ? _ref1.doScroll : void 0) != null) && (document.createEventObject != null)) {
    _old = document.onreadystatechange;
    document.onreadystatechange = function() {
      if (document.readyState === 'complete' && Odometer.options.auto !== false) {
        Odometer.init();
      }
      return _old != null ? _old.apply(this, arguments) : void 0;
    };
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      if (Odometer.options.auto !== false) {
        return Odometer.init();
      }
    }, false);
  }

  window.Odometer = Odometer;

}).call(this);

// COUNTDOWN TIMER
function getNextMonday8AM() {
  const now = new Date();
  const resultDate = new Date();
  resultDate.setHours(8, 0, 0, 0);

  let daysUntilMonday = (8 - now.getDay()) % 7;
  if (daysUntilMonday === 0 && now.getTime() >= resultDate.getTime()) {
    daysUntilMonday = 7;
  }

  resultDate.setDate(now.getDate() + daysUntilMonday);
  return resultDate.getTime();
}

// Generates the vertical HTML ribbon of digits 0-9 inside each wrapper
function initializeStrips() {
  const wrappers = document.querySelectorAll('.digit-wrapper');
  wrappers.forEach(wrapper => {
    const strip = document.createElement('div');
    strip.className = 'digit-strip';
    for (let i = 0; i <= 9; i++) {
      const num = document.createElement('span');
      num.textContent = i;
      strip.appendChild(num);
    }
    wrapper.appendChild(strip);
  });
}

// Shifts the strip vertically using CSS translate based on the digit height (3rem)
function updateDigit(elementId, value) {
  const wrapper = document.getElementById(elementId);
  if (!wrapper) return;
  const strip = wrapper.querySelector('.digit-strip');
  if (strip) {
    // -3rem matches the height of a single digit set in the CSS
    strip.style.transform = `translateY(-${value * 3}rem)`;
  }
}

function startCountdown() {
  initializeStrips();
  
  const targetTime = getNextMonday8AM();
  const container = document.getElementById("countdown-container");

  const timer = setInterval(() => {
    const now = new Date().getTime();
    const difference = targetTime - now;

    if (difference <= 0) {
      clearInterval(timer);
      if (container) {
        container.innerHTML = '<span class="status-open">Now Open</span>';
      }
      return;
    }

    // Time calculations
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    // Break numbers into tens and ones places (e.g., 42 becomes 4 and 2)
    updateDigit("days-tens", Math.floor(days / 10));
    updateDigit("days-ones", days % 10);

    updateDigit("hours-tens", Math.floor(hours / 10));
    updateDigit("hours-ones", hours % 10);

    updateDigit("minutes-tens", Math.floor(minutes / 10));
    updateDigit("minutes-ones", minutes % 10);

    updateDigit("seconds-tens", Math.floor(seconds / 10));
    updateDigit("seconds-ones", seconds % 10);
    
  }, 1000);
}

// Initialize on load
document.addEventListener("DOMContentLoaded", startCountdown);